import { getQueryParams } from "@utils/urlUtil";
import animateScrollTo from 'animated-scroll-to';
import { Col,Radio, Row } from "antd";
import React, { useEffect,useState } from "react";

import BigPictureNewsList from "./BigPictureNews/BigPictureNewsList";
import styles from "./styles.module.scss";

const BigPicture = ({
  product,
  allWordpressWpProductBigPicture,
  // text,
  // newAllAuthor,
  users
}) => {
  const { hash } = getQueryParams();
  const { product_big_picture } = product.acf;

  const scrollToSection = (idName) => {
    animateScrollTo(document.getElementById(idName), {
      elementToScroll: window,
      maxDuration: 1000,
      minDuration: 500,
      verticalOffset: -120,
    });
  };
  useEffect(() => {
    if (hash && hash!=="") {
      scrollToSection(hash)
    }
    
  }, [hash]);
  
  //Currency 1 
  const currency1_title = product_big_picture[0].post_title;
  const bigPicture1 = allWordpressWpProductBigPicture.find(
    (item) => item.wordpress_id === product_big_picture[0].ID
  );
  
  const bullishBigPicture1 = bigPicture1.acf.relate_posts.filter(
    item => item.relate_posts_type === "BULLISH"
  );
  const bearishBigPicture1 = bigPicture1.acf.relate_posts.filter(
    item => item.relate_posts_type === "BEARISH"
  );
  const currency1 = {
    name: currency1_title,
    bullish: bullishBigPicture1,
    bearish: bearishBigPicture1
  };

  //Currency 2
  let currency2_title = null;
  let bigPicture2 = null;
  if (product_big_picture[1]) {
    currency2_title = product_big_picture[1].post_title;
    bigPicture2 = allWordpressWpProductBigPicture.find(
      (item) => item.wordpress_id === product_big_picture[1].ID
    );
  };
  const bullishBigPicture2 = bigPicture2?.acf.relate_posts.filter(
    item => item.relate_posts_type === "BULLISH"
  );
  const bearishBigPicture2 = bigPicture2?.acf.relate_posts.filter(
    item => item.relate_posts_type === "BEARISH"
  );
  const currency2 = {
    name: currency2_title,
    bullish: bullishBigPicture2,
    bearish: bearishBigPicture2
  };

  const [currency, setCurrency] = useState(currency1);

  const onChangeCurrency = e => {
    if (e.target.value === "1") {
      setCurrency(currency1);
    } else setCurrency(currency2);
  };
  // const checkBearHasHighlightNews = (bigPicture, bigPicture2, currency2) => {
  //   if (
  //     !bigPicture ||
  //     bigPicture === "" ||
  //     !currency2 ||
  //     bigPicture2 === undefined ||
  //     bigPicture2.acf === undefined
  //   ) {
  //     return false;
  //   }
  //   if (
  //     (bigPicture2.acf.latest_posts &&
  //       bigPicture2.acf.latest_posts.some(
  //         (post) => post.wordpress_id === bigPicture
  //       )) ||
  //     (bigPicture2.acf.relate_posts &&
  //       bigPicture2.acf.relate_posts.some(
  //         (post) => post.wordpress_id === bigPicture
  //       ))
  //   ) {
  //     return true;
  //   } else return false;
  // };
  // const isBearHasHighlightNews = checkBearHasHighlightNews(
  //   bigPicture,
  //   bigPicture2,
  //   currency2
  // );
  
  return (
    <Row 
      gutter={[
        { xs: 0, sm: 0, md: 24, lg: 40 },
        { xs: 12, sm: 12, md: 24, lg: 40 },
      ]}
    >
      <Col 
        id="product-big-picture"
        span={24}
        className={styles.currencyOption}>
        <h2 className={styles.sectionTitle}>Bức tranh tổng quan</h2>
        <Radio.Group onChange={onChangeCurrency} defaultValue="1">
          <Radio.Button value="1">{currency1.name}</Radio.Button>
          {bigPicture2 && <Radio.Button value="2">{currency2.name}</Radio.Button>}
        </Radio.Group>
      </Col>

      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        className={styles.bullishCol}
      >
        <BigPictureNewsList 
          posts={currency.bullish} 
          users={users} 
          type="BULLISH"
        />
      </Col>

      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 12 }}
        className={styles.bearishCol}
      >
        <BigPictureNewsList 
          posts={currency.bearish} 
          users={users} 
          type="BEARISH"
        />
      </Col>
    </Row>
  );
};
export default BigPicture;
